import { ContactMatchingPhoneNumberResult } from "../Api/CallCenter/Responses/ContactMatchingPhoneNumberResult";
import { IndividualMatchingPhoneNumber } from "../Models/CallCenter/IndividualMatchingPhoneNumber";
import { ContactFacetType } from "../Models/Individuals/Enums/ContactFacetType";

class ContactMatchingPhoneNumberSearchableText {
    private readonly Item: ContactMatchingPhoneNumberResult;
    private readonly Terms: Immutable.Set<string>;
    public constructor(result: ContactMatchingPhoneNumberResult) {
        this.Item = result;
        this.Terms = this.getSearchTerms();
    }

    private addTerm(addTo: Set<string>, term: string): void {
        if (IsNullOrWhiteSpace(term)) {
            return;
        }
        addTo.add(term.trim().toLocaleLowerCase());
    }

    private getSearchTerms(): Immutable.Set<string> {
        const individual = new IndividualMatchingPhoneNumber(this.Item.Individual);
        const output = new Set<string>();
        this.addTerm(output, individual.LastName);
        this.addTerm(output, individual.FirstName);
        this.addTerm(output, individual.PreferredName);
        this.addTerm(output, individual.MiddleName);
        this.addTerm(output, individual.SecondName);
        if (individual.ContactFacetType == ContactFacetType.Patient) {
            this.addPatientTerms(output, individual);
        }
        return Immutable.Set(output);
    }

    private addPatientTerms(addTo: Set<string>, individual: IndividualMatchingPhoneNumber): void {
        const patient = individual.ToPatient();
        this.addTerm(addTo, patient.GetFormattedDateOfBirth());
        for (let term of this.Item.SearchTerms) {
            this.addTerm(addTo, term);
        }
    }

    public GetSearchTerms(): Immutable.Set<string> {
        return this.Terms;
    }

    public get ContactMatching(): ContactMatchingPhoneNumberResult {
        return this.Item;
    }
}

export { ContactMatchingPhoneNumberSearchableText };
